import authHr from "./authHr";
import commonHr from "./commonHr";
import footerHr from "./footerHr";
import galleryHr from "./galleryHr";
import menuHr from "./menuHr";
import navigationHr from "./navigationHr";
import orderHr from "./orderHr";
import paymentHr from "./paymentHr";
import statisticsHr from "./statisticsHr";

const mainHr = {
    common: commonHr,
    navigation: navigationHr,
    menu: menuHr,
    statistics: statisticsHr,
    order: orderHr,
    payment: paymentHr,
    auth: authHr,
    gallery: galleryHr,
    footer: footerHr,
};

export default mainHr;
